import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';

import { ActiveDeviceError } from '.';
import { ErrorDetailsActions } from './error-details.actions';
import { ErrorDetailsState } from './error-details.state';

export const initErrorDetailsState: ErrorDetailsState = {
  errors: [],
  allErrorsDetails: {
    allFaultCodes: [],
    loading: false,
    loaded: false,
  },
  loading: false,
  loaded: false,
};

export const errorDetailsReducer: ActionReducer<ErrorDetailsState, Action> = createReducer(
  initErrorDetailsState,
  on(
    ErrorDetailsActions.getErrorDetails.attempt,
    (state, { materialNumber, errorCode, countryCode, languageCode }): ErrorDetailsState => {
      const errorDetails = {
        faultCodes: [],
        countryCode,
        languageCode,
        loading: true,
        loaded: false,
        error: undefined,
        searchParams: {
          materialNumber,
          errorCode,
          countryCode,
          languageCode,
        },
      };

      if (
        state.errors.find(
          (error) =>
            error.searchParams.errorCode?.toLocaleLowerCase() === errorCode?.toLocaleLowerCase()
        )
      ) {
        return { ...state, errors: cloneDeep(state.errors) };
      }

      const errors = state.errors.concat(errorDetails);

      return { ...state, errors: cloneDeep(errors), loading: true, loaded: false };
    }
  ),

  on(
    ErrorDetailsActions.getErrorDetails.success,
    (state, { existingErrors }): ErrorDetailsState => {
      let errorDetails = state.errors.find((error) =>
        existingErrors.faultCodes[0]?.faultCode
          .toLocaleLowerCase()
          .includes(error.searchParams.errorCode?.toLocaleLowerCase())
      );

      if (!errorDetails) {
        const newActiveDeviceError = existingErrors as ActiveDeviceError;

        state.errors.push(newActiveDeviceError);
        errorDetails = newActiveDeviceError;
      }

      if (errorDetails) {
        errorDetails.faultCodes = existingErrors.faultCodes;
        errorDetails.countryCode = existingErrors.countryCode;
        errorDetails.languageCode = existingErrors.languageCode;
      }

      state.errors.map((error) => {
        error.loading = false;
        error.loaded = true;
      });

      return { ...state, errors: cloneDeep(state.errors), loading: false, loaded: true };
    }
  ),

  on(
    ErrorDetailsActions.getErrorDetails.failed,
    (state): ErrorDetailsState => {
      state.errors.map((error) => {
        error.loading = false;
        error.loaded = true;
      });

      return {
        ...state,
        errors: cloneDeep(state.errors),
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    ErrorDetailsActions.getAllErrorsDetails.attempt,
    (state): ErrorDetailsState => {
      return {
        ...state,
        allErrorsDetails: {
          allFaultCodes: [],
          loading: true,
          loaded: false,
        },
      };
    }
  ),

  on(
    ErrorDetailsActions.getAllErrorsDetails.aborted,
    (state): ErrorDetailsState => {
      return {
        ...state,
        allErrorsDetails: {
          ...state.allErrorsDetails,
          loading: false,
          loaded: true,
        },
      };
    }
  ),

  on(
    ErrorDetailsActions.getAllErrorsDetails.success,
    (state, { errors }): ErrorDetailsState => {
      return {
        ...state,
        allErrorsDetails: {
          allFaultCodes: errors.faultCodes,
          loading: false,
          loaded: true,
        },
      };
    }
  ),

  on(
    ErrorDetailsActions.getAllErrorsDetails.failed,
    (state): ErrorDetailsState => {
      return {
        ...state,
        allErrorsDetails: {
          allFaultCodes: [],
          loading: false,
          loaded: true,
        },
      };
    }
  ),

  on(
    ErrorDetailsActions.clearState,
    (state): ErrorDetailsState => ({
      ...state,
      errors: [],
      loading: false,
      loaded: false,
    })
  )
);
